import { MaskitoOptions } from "@maskito/core";

/**
 * Maskito mask options for a number only input
 * @param length - The length of the input
 * @returns Maskito mask options
 */
export const numberOnlyMask = (length?: number): MaskitoOptions => ({
  mask: new Array(length || 100).fill(/\d/),
});
